const VolumePerformanceTestIDs = {
  volPerfFrontlineOnlyButton: 'vol-perf-frontlineOnly-button',
  volPerfFrontlineResults: 'vol-perf-frontline-results',
  volPerfSort: 'vol-perf-sort',
  volPerfSortDefault: 'vol-perf-sort-default',
  volPerfCloseSort: 'vol-perf-close-sort',
  volPerfFiltersButton: 'vol-perf-filters-button',
  volPerfOrdersTab: 'vol-perf-orders-tab',
  volPerfScheduledTab: 'vol-perf-scheduled-tab',
  volPerfUserInfo: 'vol-perf-user-info',
  volPerfOrderStatusContainer: 'vol-perf-order-status-container',
  volPerfOrderType: 'vol-perf-order-type',
  volPerfOrderStatus: 'vol-perf-order-status',
  volPerfOrderDetails: 'vol-perf-order-details',
  volPerfQVContainer: 'vol-perf-qv-container',
  volPerfQVLabel: 'vol-perf-qv-label',
  volPerfQVValue: 'vol-perf-qv-value',
  volPerfSubtotalContainer: 'vol-perf-subtotal-container',
  volPerfSubtotalLabel: 'vol-perf-subtotal-label',
  volPerfSubtotalValue: 'vol-perf-subtotal-value',
  volPerfTotalContainer: 'vol-perf-total-container',
  volPerfTotalLabel: 'vol-perf-total-label',
  volPerfTotalValue: 'vol-perf-total-value',
  volPerfClearAllButton: 'vol-perf-clear-all-button',
  volPerfApplyFiltersButton: 'vol-perf-apply-filters-button',
  volPerfFilters: 'vol-perf-filters',
  volPerfCloseFilters: 'vol-perf-close-filters',
  volPerfFilterOrderType: 'vol-perf-filter-order-type',
  volPerfFilterOrderStatus: 'vol-perf-filter-order-status',
  volPerfFilterAccountType: 'vol-perf-filter-account-type',
  volPerfMonthDropDown: 'vol-perf-month-dropdown',
  volPerfMonthMenu: 'vol-perf-month-menu',
  volPerfMonthMenuOption: 'vol-perf-month-menu-option',
};

export default VolumePerformanceTestIDs;
